import SearchIcon from "@mui/icons-material/Search"
import { InputAdornment, TextField } from "@mui/material"
import Box from "@mui/material/Box"

type Props = {
  onChange: (value: string) => void
}

export function SearchBar({ onChange }: Props) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-end",
        paddingTop: 2,
        paddingBottom: 2,
      }}
    >
      <TextField
        fullWidth
        id="standard-search"
        label="Search"
        type="search"
        variant="outlined"
        onChange={(event) => {
          const { value } = event.target
          onChange(value)
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />
    </Box>
  )
}
